import React from 'react'
import { FormattedMessage } from 'react-intl'

import { RATING_TEXT } from 'helpers/i18n'
import { PLAYERS_COLUMN_DESCRIPTION } from '../../constants'

export const FREE_SLOT_CAPTION = (
    <FormattedMessage
        id='battle_rooms.squad.free_slot_caption'
        defaultMessage='Свободно'
    />
)

export const LOCKED_SLOT_CAPTION = (
    <FormattedMessage
        id='battle_rooms.squad.locked_slot_caption'
        defaultMessage='Автонабор легионера'
    />
)

export const JOIN_BUTTON_CAPTION = (
    <FormattedMessage
        id='battle_rooms.squad.join_button_caption'
        defaultMessage='Вступить в отряд'
    />
)

export const TOOLTIPS = {
    CLAN: {
        id: 'battle_rooms.squad.tooltips.clan',
    },
    COMMANDER: {
        id: 'battle_rooms.squad.tooltips.commander',
        message: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.commander.message'
                defaultMessage='Командир отряда'
            />
        ),
    },
    LEGIONARIES: {
        id: 'battle_rooms.squad.tooltips.legionaries',
        title: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.legionaries.title'
                defaultMessage='Легионеры'
            />
        ),
        message: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.legionaries.message'
                defaultMessage='Текущее и максимальное количество легионеров в составе отряда.'
            />
        ),
    },
    PARTICIPANT: {
        id: 'battle_rooms.squad.tooltips.participant',
    },
    PLAYERS: {
        id: 'battle_rooms.squad.tooltips.players',
        title: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.players.title'
                defaultMessage='Состав отряда'
            />
        ),
        message: PLAYERS_COLUMN_DESCRIPTION,
    },
    RATING: {
        id: 'battle_rooms.squad.tooltips.rating',
        title: RATING_TEXT,
        message: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.rating.message'
                defaultMessage='Личный рейтинг игрока.'
            />
        ),
    },
    VEHICLE: {
        id: 'battle_rooms.squad.tooltips.vehicle',
        title: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.vehicle.title'
                defaultMessage='Техника'
            />
        ),
        message: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.vehicle.message'
                defaultMessage='Машина, которую выбрал игрок.'
            />
        ),
    },
    NO_VEHICLE: {
        id: 'battle_rooms.squad.tooltips.no_vehicle',
        message: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.no_vehicle.message'
                defaultMessage='Машина не выбрана'
            />
        ),
    },
    JOIN_BUTTON: {
        id: 'battle_rooms.squad.tooltips.join',
        title: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.join.title'
                defaultMessage='Вступить в отряд'
            />
        ),
        message: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.join.message'
                defaultMessage='Нажмите, чтобы стать добровольцем и перейти к отряду.'
            />
        ),
    },
    LEGIONARY: {
        id: 'battle_rooms.squad.tooltips.legionary_slot',
        message: (
            <FormattedMessage
                id='battle_rooms.squad.tooltips.legionary_slot.message'
                defaultMessage='Легионер'
            />
        ),
    },
}



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/Squad/constants.jsx